// extracted by mini-css-extract-plugin
module.exports = {"lang":"lJ","langWrap":"lK","item":"lL","itemCurrent":"lM"};